import React from 'react'

import { Drawer } from 'antd'

import type { LntDrawerProps } from './types'

export const LntDrawer: React.FC<LntDrawerProps> = props => {
  const { children, ...restProps } = props

  return (
    <Drawer
      destroyOnClose={ true }
      { ...restProps }
    >
      { children }
    </Drawer>
  )
}
